import React,{ Component } from 'react';
import $ from 'jquery';
import { Link, browserHistory } from 'react-router';
import { ButtonToolbar, DropdownButton, MenuItem, Panel, Button, Modal  } from 'react-bootstrap';
import { ShareButtons, generateShareIcon } from 'react-share';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class SeedsList extends Component {
	constructor(props){
		super(props);
		this.state={
			seedsList: [],
			offer: {},
			sort_status: true,
			sort: '0',
			img_price: 'price.png',
			coasts: [],
			seed_filters: [],
			sort_title:'Sort By',
			coast:'0',
			nodata: false,
			img_data: 'Price',
			open: false,
			latitude: '',
			longitude: '',
			loading:false,
			web_title: '',
			web_desc: '',
			seo_title:'',
			seo_desc:'',

			cart_count:0,
			sort_coast_title:'Coasts',
			loading_gif:false,
		};
		this.showPosition=this.showPosition.bind(this);
		this.showError = this.showError.bind(this);
		this.getNearBy=this.getNearBy.bind(this);
		this.getSort=this.getSort.bind(this);
		this.getCoasts=this.getCoasts.bind(this);
		this.getSelectedCoast=this.getSelectedCoast.bind(this);
		this.getDeviceId=this.getDeviceId.bind(this);
		this.getCartCount=this.getCartCount.bind(this);
		this.getSeedFilters=this.getSeedFilters.bind(this);
	}
	getCartCount()
	{
	    var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'cart_count',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	            this.setState({
	                cart_count:data.cart_count,
	            });
	          }.bind(this),
	          error: function(err)
	          {
	          
	          }
	    });
	}
	getSeedFilters()
	{
		var data1={from: 'mobile_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'seedFilters',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
        			seed_filters:data.sort,
        		});
        	}.bind(this),
  			error: function(err)
  			{
  			}
        });
	}
	showPosition(position)
	{
	  	localStorage.setItem('lat',position.coords.latitude);
	  	localStorage.setItem('long',position.coords.longitude);
	  	this.setState({
	    	latitude: position.coords.latitude,
	    	longitude: position.coords.longitude,
	    }.bind(this));
	}
	showError(error) 
	{
	    switch(error.code) {
	        case error.PERMISSION_DENIED:
	            console.log("User denied the request for Geolocation.");
	            break;
	        case error.POSITION_UNAVAILABLE:
	            console.log("Location information is unavailable.");
	            break;
	        case error.TIMEOUT:
	            console.log("The request to get user location timed out.");
	            break;
	        case error.UNKNOWN_ERROR:
	            console.log("An unknown error occurred.");
	            break;
	        default: 
	        break;
	    }
	}	
	getDeviceId()
	{
	    if(localStorage.user_id)
	    {
	        var user_id=localStorage.user_id;
	    }
	    else
	    {
	      user_id=0;
	    }
	    var data1={from: 'mobile_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          
	        },
	        error: function(err)
	        {
	        }
	    });
    }

	getNearBy()
	{
		this.setState({
			loading_gif:true,
		});
		var data1={from: 'mobile_web',lat:this.state.latitude, long:this.state.longitude,sort:this.state.sort};
		var data2=JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'getdeals',
			dataType: 'json',
			data:{req: data2},
			success: function(data)
			{
				if(data.data.length === 0)
				{
					this.setState({
						nodata: true,
						loading_gif:false,
					})
				}
				else
				{
					this.setState({
						nodata: false,
						seedsList:data.data,
	       				offer: data,
	       				web_title: data.title,
                		web_desc: data.desc,
                		loading_gif:false,
					});
					// document.title =this.state.web_title +  " - Deals | AquaDeals | "+this.state.seo_desc;
					document.title =this.state.web_title +  " - Deals | AquaDeals ";
            		document.getElementsByTagName("META")[2].content=this.state.seo_desc;
				}
			}.bind(this),
			error: function(err)
			{
			}
		});
	}
	getCoasts()
	{
		var data1={from: 'mobile_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'coasts',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
	       			coasts:data.coasts,
	       		});
  			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}		

	componentDidMount()
	{
		if(screen.width >= 800)
		{
			window.location.href="/web/seed";
		}
		localStorage.removeItem('m_r_s_dt');
		/*if(navigator.geolocation)
		{
			navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
		}
		*/
		this.getSeedFilters();
		this.getCoasts();
		this.getDeviceId();
		if(localStorage.user_id && localStorage.token)
	    {
	      this.getCartCount();
	    }
		var data1={from: 'mobile_web',sort:'0',coast:'0'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
        			seedsList:data.data,
	       			offer: data,
	       			web_title: data.title,
	       			web_desc: data.desc,
	       			loading:true,
	       			seo_title: "Vannamei,Tiger seed deals from Hatcheries",
	       			seo_desc:'Browse quality Vannamei,Tiger seed deals from CAA approved Hatcheries, shop online and avail free shipment.',
				});
		       	// document.title =this.state.web_title+  " - Deals | AquaDeals | "+this.state.seo_desc;
		       	document.title =this.state.seo_title;
	            document.getElementsByTagName("META")[2].content=this.state.seo_desc;
			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}			
	getSort(id,type)
	{
		this.setState({
			loading_gif:true,
		});
		localStorage.setItem('sort',this.state.sort);
		var data1={from: 'mobile_web',sort:id,coast:this.state.coast};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		if(this.state.sort === 1)
	    		{
	    			var ss = 2;
	    			var img_price = 'down.png';
	    			var img_data = 'High - Low';
	    		}
	    		else
	    		{
	    			 ss = 1;
	    			 img_price = 'up.png';
	    			 img_data ='Low - High';
	    		}
	    		this.setState({
        			sort: ss,
					img_price: img_price,
					img_data: img_data,
	       			seedsList:data.data,
	       			offer: data,
	       			sort_title:type,
	       			loading_gif:false,
	       		});
  			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}
	getSelectedCoast(c,type)
	{
		if(this.state.sort === 1)
		{
			this.setState({
				sort: '2',
				loading_gif:true,
			});
		}
		else
		{
			this.setState({
				sort:'1',
				loading_gif:true,
			})
		}
		this.setState({
			coast:c,
			loading_gif:true,
		});
		var data1={from: 'mobile_web',coast: c,sort:localStorage.sort};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		if(data.data.length === 0)
        		{
        			this.setState({
        				nodata: true,
        				loading_gif:false,
        			})
        		}
        		else
        		{
        			this.setState({
        				nodata: false,
        				loading_gif:false,
        			})
        		}
        		this.setState({
	       			seedsList:data.data,
	       			offer: data,
	       			sort_coast_title:type,
	       			loading_gif:false,
	       		});
			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}
	render()
	{
	var products = this.state.seedsList.map((product, index) => (<Product key={product.deals_data.id} data={product} onUpdate={()=>this.getCartCount()} />));
	// var coasts = this.state.coasts.map((coast,index) => (<Coasts key={coast.id} data={coast} getSelectedCoast={this.getSelectedCoast} />));
	return(
	<div className="mob_deals">
		{this.state.loading ? <div className="seed_list_page mob_seedlist_page">
			<div className="page_hdr">
				<div className="container-fluid">
					<h5><Link to={"/"}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link> Seed</h5>
					<a href="/" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
					<a className="mob_cart_btn" href="/mycart">
						<img alt="" src={baseAssets+'icons/web_icons/cart_icon.png'} />
						{this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
					</a>
				</div>
			</div>
		<div className="pag_cntnt">&nbsp;</div>
		{this.state.loading_gif ? <i className="mob_loading"><img src={baseAssets+'images/mob_loading.gif'} alt="Loading" /></i> : ''}
		<section className="">
			{this.state.nodata ? <div className="no_data">
				<h3>No Deals Available</h3>
				<p>Need something here? <Link to={"/customer_care"}>CONTACT US</Link> Now !</p>
				</div> : products.length >0 ? products : <div className="no_data">
			<h3>No Deals Available</h3>
			<p>Need something here? <Link to="/customer_care">CONTACT US</Link> Now !</p>
			</div> }			
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
		</section>
		<section className="seed_sort dsl_srt">
			<ul>
				<li className="col-md-6 col-xs-6 col-sm-6 coast_list " style={{cursor:'pointer'}}>
					<ButtonToolbar >
						<DropdownButton className="test_filter_4" noCaret title={this.state.sort_title} dropup>
							<MenuItem header>Sort By</MenuItem>{this.state.seed_filters.map((seed,index) => (<MenuItem className="seed_list" eventKey={seed.id} onClick={()=>this.getSort(seed.id,seed.type)}>{seed.type}</MenuItem>))} 
						</DropdownButton>
					</ButtonToolbar>
				</li>
				{/*<li className="col-md-4 col-xs-4 col-sm-4" style={{cursor: 'pointer'}}>
				 	<a onClick={this.getSort} title=""><img src={baseAssets+'images/web_imgs/'+this.state.img_price} alt="sort" /><span>{this.state.img_data}</span></a>
				 </li>*/}
				
				<li className="col-md-6 col-xs-6 col-sm-6 coast_list " style={{cursor:'pointer'}}>
					<ButtonToolbar >
						<DropdownButton className="test_filter" noCaret title={this.state.sort_coast_title} dropup>
							<MenuItem header>Coasts : {this.state.coasts.length} </MenuItem>{this.state.coasts.map((coast,index) => (<MenuItem className="seed_list" eventKey={coast.id} onClick={()=>this.getSelectedCoast(coast.id,coast.coast)}>{coast.coast}</MenuItem>))} 
						</DropdownButton>
					</ButtonToolbar>
	      		</li>
			</ul>
		</section>
	 </div> : <div className="mob_loading"><img src={baseAssets+'images/web_imgs/mob_loading.gif'} alt="Loading" role="presentation" /> </div> }
	</div>
	);
	}
}

export class Product extends Component{
	constructor(props){
		super(props);
		this.state={
			open: false,
			shareUrl: '',
			msg: '',
			cart_count:'',
		    clearcart_status:false,
		    already_added_status:false,
		};
		this.ShareFunc=this.ShareFunc.bind(this);
		this.addToCart=this.addToCart.bind(this);
	    this.updateCartCount=this.updateCartCount.bind(this);
	    this.close=this.close.bind(this);
	    this.replaceCartItems=this.replaceCartItems.bind(this);
	    this.addToQuickCart=this.addToQuickCart.bind(this);
	    this.addToQuickCart_Onload=this.addToQuickCart_Onload.bind(this);
	}
	componentDidMount()
	{
		if(localStorage.user_id && localStorage.token && localStorage.quickbuy_onload)
		{
			this.addToQuickCart_Onload();
			localStorage.removeItem('quickbuy_onload');
			localStorage.removeItem('quickbuy_deal_id');
		}
	}

	ShareFunc(evnt)
	{
		var data1={from: 'mobile_web',type:0,did:evnt};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'createTinyurl',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
        		this.setState({
        			msg: data.msg,
        			shareUrl: data.tinyurl,
        		})
        	}.bind(this),
  			error: function(err){
  				// console.log("Error"+err);
  			}
        });
		this.setState({
			open: !this.state.open 
		});
		setTimeout(() => {this.setState({open: false}); }, 5000);
	}
	close()
  	{
	  	this.setState({
	  		clearcart_status:false,
	  		already_added_status:false,
	  	});
	}
	replaceCartItems(deal_id,quantity)
  	{
	  	if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
	  	var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:0,quantity:quantity,pl_size:0,salinity:0,pickup_date:0,source:source,campaign:campaign,url_id:url_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success")
				{
					this.setState({
						clearcart_status:false,
					});
					browserHistory.push('/mycart');
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
  	}
	updateCartCount()
	{
	  	this.props.onUpdate();
	}
	addToQuickCart(deal_id)
	{
		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
		if(!localStorage.user_id && !localStorage.token)
	  	{
	  		localStorage.setItem('seed','/seed');
	  		localStorage.setItem('quickbuy_onload','1');
	  		localStorage.setItem('quickbuy_deal_id',deal_id);
	  		browserHistory.push('/login');
		}
		else
		{
			var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:0,source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				dataType:'json',
				url: baseUrl+'addToQCart',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==="success")
					{
						this.updateCartCount();
						browserHistory.push('/quickcart');
						localStorage.removeItem('quickbuy_onload');
	  					localStorage.removeItem('quickbuy_deal_id');
					}
					else if(data.status==="error" && data.cart_flag===0)
					{
						this.setState({
							clearcart_status: true,
						});
						localStorage.removeItem('quickbuy_onload');
	  					localStorage.removeItem('quickbuy_deal_id');
					}
					else if(data.status==="error" && data.message==="Product already added to the cart")
					{
						this.setState({
							already_added_status: true,
						});
						localStorage.removeItem('quickbuy_onload');
	  					localStorage.removeItem('quickbuy_deal_id');
					}
					localStorage.removeItem('quickbuy_onload');
	  				localStorage.removeItem('quickbuy_deal_id');
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
	}
	addToQuickCart_Onload()
	{
		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
		if(!localStorage.user_id && !localStorage.token)
	  	{
	  		localStorage.setItem('seed','/seed');
	  		browserHistory.push('/login');
		}
		else
		{
			if(localStorage.user_id)
			{
				var	uid=localStorage.user_id;
			}
			else
			{
				uid=0;
			}
			if(localStorage.quickbuy_deal_id)
			{
				var deal_id=localStorage.quickbuy_deal_id;
			}
			else
			{
				deal_id=0;
			}
			var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:0,source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				dataType:'json',
				url: baseUrl+'addToQCart',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==="success")
					{
						this.updateCartCount();
						browserHistory.push('/quickcart');
						localStorage.removeItem('quickbuy_deal_id');
						localStorage.removeItem('quickbuy_onload');
					}
					else if(data.status==="error" && data.cart_flag===0)
					{
						this.setState({
							clearcart_status: true,
						});
						localStorage.removeItem('quickbuy_deal_id');
						localStorage.removeItem('quickbuy_onload');
					}
					else if(data.status==="error" && data.message==="Product already added to the cart")
					{
						this.setState({
							already_added_status: true,
						});
						localStorage.removeItem('quickbuy_deal_id');
						localStorage.removeItem('quickbuy_onload');
					}
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
	}
	addToCart(deal_id)
  	{
	 	if(!localStorage.user_id && !localStorage.token)
	  	{
	  		localStorage.setItem('seed','/seed');
	  		browserHistory.push('/login');
		}
		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
	  	var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:0,source:source,campaign:campaign,url_id:url_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'quickBuy',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success")
				{
					this.updateCartCount();
					browserHistory.push('/mycart');
				}
				else if(data.status==="error" && data.cart_flag===0)
				{
					this.setState({
						clearcart_status: true,
					});
				}
				else if(data.status==="error" && data.message==="Product already added to the cart")
				{
					this.setState({
						already_added_status: true,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
  	}
	render()
	{
		var mydata=this.props.data;
		var shareUrl = this.state.shareUrl;
		var title = "Hey Click here "+ shareUrl  + " to check " + mydata.deals_data.sname + " from AquaDeals.";
		var description=shareUrl;
		var no_data='';
		if(mydata.length === 0)
		{
			no_data=<div className="no_data">
						<h3>No Deals Available</h3>
						<p>Need something here? <Link to={"/customer_care"}>CONTACT US</Link> Now !</p>
					</div>;
		}
		else
		{
			no_data="";
		}

		return(
			<div className="list_card seedlist_card">
					{no_data}
					{mydata.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+mydata.promo_ribbion} alt="" /></i> : ''}
					<Link to={"/sdetails/"+mydata.deals_data.sname+"/"+mydata.deals_data.id}>
						<div className="list_img">
							<img src={baseAssets+'images/seller_imgs/thumbnails/'+mydata.deals_data.image} alt=" " role="presentation" />
						</div>
						<div className="list_txt">
							<h4 style={{color:'#333'}}>{mydata.deals_data.sname}</h4>
							<h5>{mydata.deals_data.oname}</h5>
							{mydata.deals_data.price ? <p><span></span><span style={{color:'#333'}}>&#8377; </span><span style={{color:'#666'}}>{mydata.deals_data.price}</span></p> : ''}
							{mydata.offer > 0 ? <h5 className="seed_price"><span>&#8377; </span>{mydata.offer} off on 1M</h5> : ''}
							{mydata.deals_data.discount_price > 0 ? <h5 className="seed_price"><span>&#8377; </span>{mydata.offer} off on 1M</h5> : ''}
						 	{/* {mydata.deals_data.discount_price > 0 ? <p><span className="offer_old">&#8377;{mydata.deals_data.price}</span><span className="offer_new">&#8377;{mydata.deals_data.discount_price}</span></p> : <p><span className="offer_new_single">&#8377;{mydata.deals_data.price}</span></p>  } */}
							{mydata.deals_data.rate >=1  ? <h6><i><img src={baseAssets+'images/web_imgs/star_filled.png'} width="16px" role="presentation"/></i>{mydata.deals_data.rate}</h6> : <h6><i><img src={baseAssets+'images/web_imgs/star_gray.png'} width="16px" role="presentation"/></i></h6> }  
						</div>
					</Link>
					<Link className="share_list" onClick={()=>{this.ShareFunc(mydata.deals_data.id)}}>
						<img src={baseAssets+'images/web_imgs/share1.png'} alt="share" />
					</Link>
					{mydata.view_status >0 ? <h6 className="views_eye"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" role="presentation"/> {mydata.view_status} {mydata.view_status >1  ? 'Views' : 'View'}</h6> : ''}
					{/*<a className="seed_quick_buy_img" onClick={()=>this.addToCart(mydata.deals_data.id)}><img src="https://aquadeals.in/admin/assets/images/icons/quick_buy.png" alt=" " width="50px" /></a>*/}
					<a className="seed_quick_buy_img" onClick={()=>this.addToQuickCart(mydata.deals_data.id)}><img src="https://aquadeals.in/admin/assets/images/icons/quick_buy.png" alt=" " width="50px" /></a>
					<div>
						<Panel className="share_panel" collapsible expanded={this.state.open}>
							<FacebookShareButton url={shareUrl} quote={title} className="test_share">
					            <FacebookIcon size={32} round />
					        </FacebookShareButton>
					        <TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share">
					            <TwitterIcon size={32} round />
					        </TwitterShareButton>
							<GooglePlusShareButton url={shareUrl} quote={title} descirption={description} className="test_share">
					            <GooglePlusIcon size={32} round />
					        </GooglePlusShareButton>
				       </Panel>
					</div>
					{/* Modal for Replaceing the other cart items */}
				    <Modal className="m_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
						<Modal.Header closeButton>
				    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
				  		</Modal.Header>
				  		<Modal.Body>
				  			<h4 style={{fontSize:'14px', color:'#333'}}>You can't have multiple seller items in the cart. Empty existing cart & add this item {mydata.deals_data.sname}?</h4>
				  		</Modal.Body>
				  		<Modal.Footer className="modal_footer">
								<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
								<a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.replaceCartItems(mydata.deals_data.id,mydata.deals_data.min_allowed_qty)}}>YES</Button></a>
				  		</Modal.Footer>
					</Modal>

					{/* Modal for Showing the response of Already existing product */}
					<Modal className="m_pro_full_dtls_modal"  show={this.state.already_added_status} onHide={this.close}  >
						<Modal.Header closeButton>
				    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
				  		</Modal.Header> 
				  		<Modal.Body>
				  			<h4 style={{fontSize:'14px', color:'#333'}}>Product already added to the cart</h4>
				  		</Modal.Body>
				  		<Modal.Footer className="modal_footer">
								<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>OK</Button>
						</Modal.Footer>
					</Modal>
			</div>
		);
	}
}





/** WEBPACK FOOTER **
 ** ./src/components/Categories/Seed/SeedsList.js
 **/